/**
 * 地圖 POI 行政區解析（委派 /api/poi/locate、/api/poi/district-at）
 */

/**
 * @param {string} districtLabel
 * @param {string} [countyHint]
 * @returns {Promise<{countyCode:string,districtZh:string,districtSlug:string}|null>}
 */
export async function locatePoiDistrict(districtLabel, countyHint = null) {
    if (!districtLabel) return null;
    const params = new URLSearchParams({ q: districtLabel });
    if (countyHint) params.set('county', countyHint);
    const res = await fetch(`/api/poi/locate?${params}`, { credentials: 'include' });
    if (!res.ok) return null;
    return res.json();
}

/**
 * @param {number} lat
 * @param {number} lng
 */
export async function locatePoiDistrictAt(lat, lng) {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    const params = new URLSearchParams({ lat: String(lat), lng: String(lng) });
    const res = await fetch(`/api/poi/district-at?${params}`, { credentials: 'include' });
    if (!res.ok) {
        let detail = '';
        try {
            const body = await res.json();
            detail = body?.error || body?.message || '';
        } catch {
            /* ignore */
        }
        const err = new Error(detail || `HTTP ${res.status}`);
        err.status = res.status;
        err.detail = detail;
        throw err;
    }
    return res.json();
}
